import React from 'react';
import Router from './router/Router';
import './App.css';

const App: React.FC = () => {
  return <Router />;
};

export default App;
